import { render } from "./Deneme.vue?vue&type=template&id=4b49a809&scoped=true&ts=true"
import script from "./Deneme.vue?vue&type=script&lang=ts"
export * from "./Deneme.vue?vue&type=script&lang=ts"

import "./Deneme.vue?vue&type=style&index=0&id=4b49a809&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b49a809"]])

export default __exports__